<template>
	<div data-tour-scope="setting-packaging">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ $vuetify.lang.t('$vuetify.front.subsetting.packagings') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items>
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn elevation="0" text title="Nuovo packaging" data-tour="add" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>


						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="4" data-tour="search">
									<v-text-field v-model="searchfield" label="Cerca per nome" outlined append-icon="mdi-magnify" dense hide-details @click:append="getSearch()" @keyup.enter="getSearch()"></v-text-field>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							:headers="headers"
							:items="getPackagings"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							data-tour="table"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="packaging-cards">
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="grey--text text-left px-3 py-3">{{ vuoto }}</td>
									</tr>
									<tr v-for="(item, index) in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.name || 'Packaging'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu left eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" :data-tour="index === 0 ? 'row-menu' : null">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="deleteItem(item)">
																<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Status</span>
													<v-switch v-model="item.status" :data-tour="index === 0 ? 'switch' : null" @change="changeStatus(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="grey--text text-left">{{ vuoto }}</td>
									</tr>
									<tr v-for="(item, index) in items" :key="item._id">
										<td class="pl-0 pr-0" style="width: 40px">
											<v-menu right eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon small color="primary" v-bind="attrs" v-on="on" :data-tour="index === 0 ? 'row-menu' : null">
														<v-icon>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="deleteItem(item)">
														<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td>
											<v-switch v-model="item.status" :data-tour="index === 0 ? 'switch' : null" @change="changeStatus(item)" color="primary" class="mt-0" hide-details></v-switch>
										</td>
										<td class="font-weight-medium text-left">{{ item.name }}</td>
										<td class="text-left">
											<span class="pk-misure">
												<v-icon small class="mr-1">mdi-package-variant-closed</v-icon>
												{{ misure(item) }}
											</span>
										</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
		<v-dialog v-model="dialogconfirm" max-width="380">
			<v-card>
				<v-card-title class="headline">Eliminare il packaging «{{ daEliminare ? daEliminare.name : '' }}»?</v-card-title>
				<v-card-text class="text-left">Non sarà più possibile ripristinarlo.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="error" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { listRouteState } from '@/components/core/list/listRouteState';
import { createPackagingTourSteps } from './packaging-tour';

const LIST_SIZE = [15, 25, 50, 100];
const SEARCH_MIN = 3;

export default {
	name: 'Packaging',
	// pagina, righe, ordinamento e ricerca stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createPackagingTourSteps()) };
	},
	components: {
		TourOverlay,
		KeyValueCard,
	},
	data() {
		return {
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// default, sovrascritti da quello che c'e' nell'URL
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {},
				options: {
					sortBy: ['name'],
					sortDesc: [false],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			listSize: LIST_SIZE,
			searchfield: '',
			total: 0,
			headers: [
				{ text: '', value: 'menu', sortable: false },
				{ text: 'Status', value: 'status' },
				{ text: 'Nome', value: 'name' },
				{ text: 'Misure (lungh. × largh. × alt.)', value: 'misure', sortable: false },
			],
			dialogconfirm: false,
			// packaging in attesa di conferma nel dialog di eliminazione
			daEliminare: null,
		};
	},
	mounted() {
		this.listLoad();
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		vuoto() {
			return this.settings.search ? 'Nessun packaging trovato con questa ricerca' : 'Nessun packaging: aggiungilo con il +';
		},
		...mapGetters({
			getPackagings: 'packagings/getPackagings',
		}),
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			destroyData: 'packagings/destroyData',
			fetchItems: 'packagings/asyncFetchData',
			setUpdateStatus: 'packagings/setUpdateStatus',
			deletePackagings: 'packagings/deletePackaging',
		}),
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			return [{ label: 'Misure', value: this.misure(item) }];
		},
		// "30 × 20 × 10 cm"
		misure(item) {
			const n = v => (v === null || v === undefined || v === '' ? '?' : Number(v).toLocaleString('it-IT'));
			return `${n(item.length)} × ${n(item.width)} × ${n(item.height)} cm`;
		},
		notifica(color, text) {
			this.snackbar.color = color;
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= SEARCH_MIN ? this.searchfield : '';
		},
		// ritorna la promessa: confirmDelete aspetta il ricaricamento prima del messaggio
		async getDataFromApi() {
			this.setPreload(true);
			try {
				const result = await this.fetchItems(this.settings);
				this.total = result ? result.total : 0;
			} finally {
				this.setPreload(false);
			}
		},
		// inserimento e modifica sono pagine: la lista resta nel suo URL e ci si torna uguale
		createItem() {
			this.$router.push('/setting/packaging/new');
		},
		editItem(item) {
			this.$router.push(`/setting/packaging/${item._id}`);
		},
		deleteItem(item) {
			this.daEliminare = item;
			this.dialogconfirm = true;
		},
		async confirmDelete() {
			this.dialogconfirm = false;
			const item = this.daEliminare;
			this.daEliminare = null;
			if (!item) return;
			this.setPreload(true);
			const result = await this.deletePackagings([item]);
			this.setPreload(false);
			if (!result || result.error) {
				this.notifica('error', 'Eliminazione non riuscita');
				return;
			}
			await this.getDataFromApi();
			this.notifica('success', 'Packaging eliminato');
		},
		async changeStatus(item) {
			this.setPreload(true);
			const result = await this.setUpdateStatus({ _id: item._id, status: item.status });
			this.setPreload(false);
			if (result && result.data) {
				this.notifica('success', item.status ? 'Packaging attivato' : 'Packaging disattivato');
			} else {
				item.status = !item.status;
				this.notifica('error', 'Aggiornamento non riuscito');
			}
		},
	},
};
</script>

<style scoped>
.pk-misure {
	display: inline-flex;
	align-items: center;
	white-space: nowrap;
	font-variant-numeric: tabular-nums;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.packaging-cards,
.packaging-cards tr {
	display: block;
	width: 100%;
}
.packaging-cards tr,
.packaging-cards tr:hover {
	background: transparent !important;
}
.packaging-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.packaging-cards tr:first-child td {
	padding-top: 12px !important;
}
.packaging-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.packaging-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
